<template>
  <div class="slots">
    <van-popup v-model="showPop" round :style="{width:'80%'}" :close-on-click-overlay="false" get-container="body">
      <div class="content">
        <van-form 
          :show-error-message="false" 
          validate-trigger="onSubmit" 
          validate-first
          input-align="right"
          ref="form"
        >
          <van-field
            required
            readonly
            clickable
            right-icon="arrow"
            v-model="prizeImgTypeStr"
            label="图片类型"
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择图片类型' }]"
            @click="changePicker(1)"
          />
          <van-field required label="奖品图片" v-if="prize.prizeImgType">
            <template #input>
              <van-uploader
                :max-count="1"
                :before-read="beforeImgUpload" 
                :fileList="prize.prizeImgList" 
                :after-read="uploadImg"
                @delete="(file) => deleteImg(file)"
              />
            </template>
          </van-field>
          <van-field
            required
            v-model="prize.prizeName"
            maxlength="15"
            label="奖品名称"
            placeholder="请输入"
            :rules="[{ required: true, message: '请输入奖品名称' }]"
          />
          <van-field
            required
            v-model="prize.inventory"
            type="digit"
            label="库存"
            placeholder="请输入"
            :rules="[{ required: true, message: '请输入库存' }]"
            @blur="checkFeeValid('inventory')"
          />
          <van-field
            v-if="from == 'manager' && !prize.isNewAdd"
            disabled
            v-model="prize.soldNumber"
            type="digit"
            label="已兑换"
            placeholder="请输入"
          />
          <van-field
            required
            readonly
            clickable
            :disabled="from == 'manager' && !prize.isNewAdd"
            right-icon="arrow"
            v-model="prize.prizeTypeStr"
            label="奖品类型"
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择奖品类型' }]"
            @click="changePicker(2)"
          />
          <van-field
            required
            v-model="prize.canExchangeTimes"
            type="digit"
            label="单人可兑换次数"
            label-width="7em"
            placeholder="请输入"
            :rules="[{ required: true, message: '请输入单人可兑换次数' }]"
            @blur="checkFeeValid('canExchangeTimes')"
          />
          <div class="title">该奖品兑换条件</div>
          <div class="tips">填写该奖品需要哪些签才能兑换，至少要选1个签</div>
          <template v-for="(item,index) in prize.conditions">
            <van-field
              :key="index"
              type="digit"
              v-model="item.exchangeNeedNumber"
              :label="item.drawLotsTitle"
              placeholder="请输入"
              :formatter="formatter"
            >
              <span slot="right-icon">份</span>
            </van-field>
          </template>
        </van-form>
        <div class="footer" v-show="bottomIsShow">
          <div class="button cancel" @click="cancel">取消</div>
          <div class="button" @click="submit">
            {{from == 'manager' ? '保存并上架' : '保存'}}
          </div>
        </div>
        <div style="height:66px"></div>
      </div>
    </van-popup>
    <van-action-sheet v-model="isSheet"  cancel-text="取消" :actions="actions" @select="onSelect" get-container="body"/>
    <!-- <div class="h5-cropper">
      <h5-cropper ref="cropper" :option="option" @getFile="getFile" @canceltailor="canceltailor"></h5-cropper>
    </div> -->
    <van-popup v-model="isOverlay" :style="{width:'100%'}" :close-on-click-overlay="false" get-container="body">
      <div class="cropper">
        <h5-cropper ref="cropper" :option="option" @getFile="getFile" @canceltailor="canceltailor"></h5-cropper>
      </div>
    </van-popup>
   
  </div>
</template>

<script>
import H5Cropper from 'vue-cropper-h5'
import { round2Places } from "@/utils/utils";
export default {
  components: {
    H5Cropper
  },
  props: {
    isAddPrizePop: {
      type: Boolean,
      default: false
    },
    prize: {
      type: Object,
      default() {
        return {}
      }
    },
    defaultPhoneHeight: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      bottomIsShow:true,//控制底部tabbar显示与隐藏
      nowPhoneHeight:0, //屏幕现在的高度
      isSheet: false,
      isUploadImg: false,
      sheetType: 1,
      prizeImgTypeStr: '',
      option: {
        ceilbutton: true,
        fixed: false,
        autoCropWidth: 514/2,
        autoCropHeight: 273/2
      },
      actions: [{name: '实物', type: 1}, {name: '虚拟', type: 2}],
      isClike: true,
      isOverlay: false
    }
  },
  watch:{
    nowPhoneHeight:function(){
      if(this.defaultPhoneHeight != this.nowPhoneHeight){
        // 当软键盘弹出,改变bottomIsSHow变量然后去控制bottom的显示与隐藏
        this.bottomIsShow=false;
      }else{
        // 相等代表软键盘收起后,与上同理
        this.bottomIsShow=true
      }
    },
  },
  computed: {
    showPop: {
      get() {
        if (this.isAddPrizePop) {
          this.initSheet()
        }
        return this.isAddPrizePop
      },
      set(val) {
        this.$emit('update:isAddPrizePop', val)
      }
    },
    from() {
      return this.$route.query.from
    },
  },
  methods: {
    changePicker(type) {
      this.sheetType = type
      if (type == 1) {
        this.actions = [{name: '横图', type: 'horizontal'}, {name: '竖图', type: 'vertical'}]
      }else {
        this.actions = [{name: '实物', type: 1}, {name: '虚拟', type: 2}]
      }
      if (this.from == 'manager' && !this.prize.isNewAdd && type == 2) return
      this.isSheet = true
    },
    onSelect(obj) {
      const { name, type} =  obj
      if (this.sheetType == 1) {
        this.deleteImg()
        this.prize.prizeImgType = type
        this.prizeImgTypeStr = name
        if (type == 'horizontal') {
          this.option.autoCropWidth = 514/2
          this.option.autoCropHeight = 273/2
        }else {
          this.option.autoCropHeight = 514/2
          this.option.autoCropWidth = 273/2
        }
      }else {
        this.prize.prizeType = type
        this.prize.prizeTypeStr = name
      }
     
      this.isSheet = false
    },
    initSheet() {
      this.prizeImgTypeStr = ''
      if (this.prize.prizeImgType != '') {
        if (this.prize.prizeImgType == 'horizontal') {
          this.prizeImgTypeStr = '横图' 
          this.option.autoCropWidth = 514/2
          this.option.autoCropHeight = 273/2
        }else {
          this.prizeImgTypeStr = '竖图' 
          this.option.autoCropHeight = 514/2
          this.option.autoCropWidth = 273/2
        }
       
      }
    },
    beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }
      return true;
    },
    uploadImg(e) {
      this.isOverlay = true
      this.$nextTick(()=>{
        this.$refs.cropper.loadFile(e.file)
      })
      this.showPop = false
    },
    getFile(file) {
      this.isOverlay = false
      this.showPop = true
      this.isUploadImg = true
      const currentFile = {
        url: '',
        status:'uploading',
        message: '上传中...'
      }
      this.prize.prizeImgList.push(currentFile)
      this.$api.common.uploadImg(file)
        .then(({data}) => {
          if (data && data[0]) {
            const fileUrl = data[0].fileUrl;
            currentFile.url = fileUrl
            currentFile.status = 'done'
            delete this.prize.prizeImgList[0].status
            delete this.prize.prizeImgList[0].message
            this.isUploadImg = false
          }
        })
        .catch(err => {
          this.isUploadImg = false
          this.prize.prizeImgList = []
      });
    },
    deleteImg(file) {
      this.prize.prizeImgList = []
      this.prize.prizeImg = ''
    },
    canceltailor() {
      this.isOverlay = false
      this.showPop = true
    },
    formatter(value) {
      value = round2Places(value)
      if (value > 999999) {
        value = 999999
      }else if(value < 0) {
        value = 0
      }
      return value
    },
    checkFeeValid(fieldName) {
      let parame = this.prize[fieldName]
      this.prize[fieldName] = round2Places(parame)
      if (parame > 999999) {
        this.prize[fieldName] = 999999
        return
      }
    },
    submit() {
      // 图片上传中
      if (this.isUploadImg) return
      
      if (this.isClike) {
        this.isClike = false
        this.$refs.form.validate().then(async res => {
          if (!this.prize.prizeImgList.length) {
            this.$toast('请上传奖品图');
            return
          }
          let drawLotsValueArr = []
          this.prize.conditions.forEach(item => {
            if (item.exchangeNeedNumber && item.exchangeNeedNumber > 0) {
              drawLotsValueArr.push(item.exchangeNeedNumber)
            }
          })
          if (drawLotsValueArr.length == 0) {
            this.$toast('奖品兑换条件必填写一个');
             this.isClike = true
            return
          }
          this.prize.prizeImg =  this.prize.prizeImgList[0].url
          const { isNewAdd, inventory,soldNumber = 0} = this.prize
          if (this.from == 'manager' ) {
            if (!isNewAdd && (Number(inventory) < Number(soldNumber))) {
              this.$toast('库存数不可小于已兑换数量1')
              this.isClike = true
              return
            }else {
              const {inventory,soldNumber = 0} = this.prize
              const res = await this.$api.drawlots.savePrizeAndOnline(this.prize)
                .finally(_=> {
                  this.isClike = true
                })
              if (res.data) {
                this.prize.id = res.data
                this.prize.residueNumber = this.prize.inventory
              }
              this.prize.residueNumber = inventory - soldNumber
              this.prize.status = 0
            }
          }
          this.$toast('保存成功')
          this.$emit('prizeSaveSuccess', this.prize)
          this.showPop = false
          setTimeout(()=> {
            this.isClike = true
          },1500)
        }).catch(err => {
          this.$toast(err[0].message);
          this.isClike = true
        })
      }
    },
    cancel() {
      this.showPop = false
      this.isClike = true
    },
  },
  mounted() {
    window.onresize = ()=>{ //这个方法会被调用两次,软键盘弹出后和软件收起后
      this.nowPhoneHeight = window.innerHeight 
    }
  },
  destroyed() {
    //页面销毁前要记得这个监听消除掉;
    window.onresize = null
  }
}
</script>

<style lang="stylus" scoped>
.content {
  padding-top: 10px;
  height: 500px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  .title {
    margin:10px 0 0 10px;
  }
  .tips {
    font-size: 10px;
    color: #bbb;
    margin: 6px 0 6px 10px;
  }
  .footer {
    box-sizing: border-box
    position absolute;
    left 0
    bottom 0
    height 60px
    width 100%
    display: flex
    align-items: center
    justify-content: space-around
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    border-bottom-left-radius: 16px
    border-bottom-right-radius: 16px
    background-color #fff;
    .button {
      padding 10px 40px
      border 1px solid $mainTextColor
      border-radius: 8px
      color #fff
      background-color: $mainTextColor
    }
    .cancel {
      color $mainTextColor
      background: #fff;
    }
  }
  // .h5-cropper {
  //   position: absolute;
  //   left: -1000px;
  //   background: red;
  // }
}
.cropper {
  height: 100vh;
}
</style>